import _classCallCheck from "/home/jenkins/workspace/builder_node16/klinikasmyka_10.200.0.62/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/jenkins/workspace/builder_node16/klinikasmyka_10.200.0.62/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    _classCallCheck(this, Subscribable);
    this.listeners = [];
    this.subscribe = this.subscribe.bind(this);
  }
  _createClass(Subscribable, [{
    key: "subscribe",
    value: function subscribe(listener) {
      var _this = this;
      this.listeners.push(listener);
      this.onSubscribe();
      return function () {
        _this.listeners = _this.listeners.filter(function (x) {
          return x !== listener;
        });
        _this.onUnsubscribe();
      };
    }
  }, {
    key: "hasListeners",
    value: function hasListeners() {
      return this.listeners.length > 0;
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe() {// Do nothing
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {// Do nothing
    }
  }]);
  return Subscribable;
}();
export { Subscribable };